import { render, staticRenderFns } from "./percentage-store-expenses.vue?vue&type=template&id=d489d3d8&scoped=true&"
import script from "./percentage-store-expenses.vue?vue&type=script&lang=js&"
export * from "./percentage-store-expenses.vue?vue&type=script&lang=js&"
import style0 from "./percentage-store-expenses.vue?vue&type=style&index=0&id=d489d3d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d489d3d8",
  null
  
)

export default component.exports